import { useState } from 'react';
import { Container, Grid } from '@mui/material';
import '../styles.scss';

export default function Pregunta13({ setRespuesta, cambiarPregunta, sumarPuntos }) {
	const [seleccionadas, setSeleccionada] = useState([]);
	const [btn1, setBtn1] = useState(false);
	const [btn2, setBtn2] = useState(false);
	const [btn3, setBtn3] = useState(false);
	const [btn4, setBtn4] = useState(false);
	const [correctas] = useState(['a) Crear recordatorios visuales durante las sesiones programadas durante la semana.', 'b) Establecer metas de seguimiento diarias con incentivos simbólicos.', 'd) Rediseñar el proceso de seguimiento para simplificarlo.']);

	const grabarSeleccionada = (opc) => {
		const array = seleccionadas;
		array.push(opc);
		setSeleccionada(array);
	};

	const siguiente = () => {
		if (seleccionadas.toString() === correctas.toString()) {
			setRespuesta('pregunta13', seleccionadas, 1);
			console.log('si');

			sumarPuntos(1);
		} else {
			setRespuesta('pregunta13', seleccionadas, 0);
			console.log('no');

			sumarPuntos(0);
		}
		cambiarPregunta(14);
	};

	return (
		<>
			<Container maxWidth='lg'>
				<Grid container justifyContent='center' alignItems='center' spacing={4}>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div className='pregunta'>
							<div className='num-pregunta'>13.</div> Tus asesores han mostrado baja iniciativa para realizar seguimientos proactivos con los clientes. ¿Qué estrategias de Nudging implementarías para impulsarlos?
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div
							className={`${btn1 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								setBtn1(!btn1);
								grabarSeleccionada('a) Crear recordatorios visuales durante las sesiones programadas durante la semana.');
							}}
						>
							<div className='letra'>{`a)`}</div>
							<div className='texto-respuesta'>Crear recordatorios visuales durante las sesiones programadas durante la semana.</div>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div
							className={`${btn2 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								setBtn2(!btn2);
								grabarSeleccionada('b) Establecer metas de seguimiento diarias con incentivos simbólicos.');
							}}
						>
							<div className='letra'>{`b)`}</div>
							<div className='texto-respuesta'>Establecer metas de seguimiento diarias con incentivos simbólicos.</div>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div
							className={`${btn3 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								setBtn3(!btn3);
								grabarSeleccionada('c) Incrementar la supervisión directa para asegurar el cumplimiento.');
							}}
						>
							<div className='letra'>{`c)`}</div>
							<div className='texto-respuesta'> Incrementar la supervisión directa para asegurar el cumplimiento.</div>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div
							className={`${btn4 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								setBtn4(!btn4);
								grabarSeleccionada('d) Rediseñar el proceso de seguimiento para simplificarlo.');
							}}
						>
							<div className='letra'>{`d)`}</div>
							<div className='texto-respuesta'> Rediseñar el proceso de seguimiento para simplificarlo.</div>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div className='siguiente' onClick={() => siguiente()}>
							Siguiente
						</div>
					</Grid>
				</Grid>
			</Container>
		</>
	);
}
